<div class="container mt-4 mb-5">
  <div class="topNavH"></div>
  <div class="text-end mb-3">
    <app-settings-offcanvas></app-settings-offcanvas>
  </div>
  <h2 class="mb-4 bigTitleCol">{{ 'SUMMARY.PAGE_TITLE' | translate }} - {{ 'STUDENT_SUMMARY.STUDENTS_FOR_ACTIVE_APPLICATION_SUBTITLE' | translate }}</h2>
  <hr>

  <div *ngIf="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
    </div>
    <p class="mt-2">{{ 'HOME.LOADING_STUDENTS' | translate }} </p>
  </div>

  <div *ngIf="errorMessage && !isLoading" class="alert alert-warning text-center" role="alert">
    {{ errorMessage | translate }}
  </div>
  <div *ngIf="!isLoading && !errorMessage && students.length > 0">
    <div class="list-group">
      <div *ngFor="let student of students; let i = index"
           class="list-group-item list-group-item-action flex-column align-items-start mb-3 shadow-sm"
           style="cursor: default;">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">
            {{ 'STUDENT_SUMMARY.STUDENTS' | translate }} {{ getAlphabeticalIndex(i) }}
            {{ getCurrentStudentName(student) | translate }}
            <span class="text-danger">*</span>{{ 'SUMMARY.UNCLICKABLE' | translate }}
          </h5>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isLoading && students.length === 0 && !errorMessage" class="alert alert-info text-center">
    {{ 'STUDENT_SUMMARY.NO_STUDENTS_FOR_APPLICATION' | translate }}
  </div>

  <hr class="my-4">

  <div class="text-center">
    <button class="btn button-primary-purple btn-lg mt-4" (click)="goToAddStudentPage()">
      {{ 'STUDENT_SUMMARY.ADD_NEW_STUDENT_BUTTON' | translate }}
    </button>
  </div>
</div>
